import { c as _c } from "react/compiler-runtime";
import { useField, useFormikContext } from 'formik';
import { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { getMsIntervalByUnit, INTERVAL_TIME_UNITS } from '../../../../utils/rules';
import { useTeamPermission } from '../../../contexts/TeamPermissionContext';
import Text from '../../base/Text';
import { Div, StyledUtilsProps } from '../../helpers/StyledUtils';
import SelectInput from './SelectInput';
import { StyledButton } from '../../base/Button';
import { fieldName } from '../../../../utils';
interface Props extends StyledUtilsProps {
  label?: string;
  name: string;
  help?: string;
  type?: string;
  placeholder?: string;
  auto_complete?: string;
  required?: boolean;
  min_interval?: keyof typeof INTERVAL_TIME_UNITS;
  max_interval?: keyof typeof INTERVAL_TIME_UNITS;
  z_index?: number;
}
const StyledFieldWrapper = styled(Div)(({
  theme
}) => css`
    display: flex;
    max-width: 100%;
    border-radius: ${theme.radius.normal};
    box-shadow: ${theme.shadows.neutral.base};
    input {
      padding: ${theme.spacing(1.25)} ${theme.spacing(2)};
      border-radius: ${theme.radius.normal};
      width: 54px;
      line-height: ${theme.pxToRem(theme.font_sizes.m.line_height)};
      box-shadow: none;
      border: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;

      &:focus {
        z-index: 1;
        outline-offset: 2px;
      }
    }

    ${StyledButton} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 120px !important;
      box-shadow: none;
      border: none;
      border-left: 1px solid ${theme.colors.outline.neutral};
    }
  `);
const IntervalInput: React.FC<Props> = t0 => {
  const $ = _c(52);
  const {
    label,
    name,
    placeholder,
    auto_complete,
    required,
    help,
    min_interval,
    max_interval
  } = t0;
  const {
    authorized
  } = useTeamPermission();
  const [, t1, t2] = useField(name);
  const {
    value,
    error,
    touched
  } = t1;
  const {
    setValue,
    setTouched
  } = t2;
  let t3;
  if ($[0] !== name) {
    t3 = fieldName(name, "time_unit");
    $[0] = name;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [, t4, t5] = useField(t3);
  const {
    value: time_unit_value
  } = t4;
  const {
    setValue: setTimeUnitValue
  } = t5;
  const {
    submitCount
  } = useFormikContext();
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = Object.keys(INTERVAL_TIME_UNITS);
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== max_interval || $[4] !== min_interval) {
    t7 = t6.filter(unit => {
      if (min_interval && INTERVAL_TIME_UNITS[unit] < INTERVAL_TIME_UNITS[min_interval]) {
        return false;
      }
      if (max_interval && INTERVAL_TIME_UNITS[unit] > INTERVAL_TIME_UNITS[max_interval]) {
        return false;
      }
      return true;
    });
    $[3] = max_interval;
    $[4] = min_interval;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const time_unit_options = t7;
  let t8;
  if ($[6] !== setTimeUnitValue || $[7] !== time_unit_value || $[8] !== value) {
    t8 = () => {
      if (value && !time_unit_value) {
        const [, time_unit] = getMsIntervalByUnit(value);
        setTimeUnitValue(time_unit);
      }
    };
    $[6] = setTimeUnitValue;
    $[7] = time_unit_value;
    $[8] = value;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  useEffect(t8, t9);
  let t10;
  if ($[11] !== label || $[12] !== name) {
    t10 = label && <Text as="label" semi={true} size="s" htmlFor={name}>{label}</Text>;
    $[11] = label;
    $[12] = name;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      align: "center",
      gap: 3
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = !authorized;
  const t13 = value ? value / INTERVAL_TIME_UNITS[time_unit_value] : "";
  let t14;
  if ($[15] !== setTouched || $[16] !== setValue || $[17] !== time_unit_value) {
    t14 = e => {
      const value_0 = parseInt(e.target.value);
      setTouched(true);
      if (value_0 > 0) {
        setValue(parseInt(e.target.value) * INTERVAL_TIME_UNITS[time_unit_value]);
      } else {
        setValue("");
      }
    };
    $[15] = setTouched;
    $[16] = setValue;
    $[17] = time_unit_value;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== auto_complete || $[20] !== placeholder || $[21] !== required || $[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
    t15 = <input type="number" placeholder={placeholder} autoComplete={auto_complete} required={required} disabled={t12} value={t13} max={9999} onChange={t14} />;
    $[19] = auto_complete;
    $[20] = placeholder;
    $[21] = required;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== name) {
    t16 = fieldName(name, "time_unit");
    $[26] = name;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== setValue || $[29] !== time_unit_value || $[30] !== value) {
    t17 = unit_0 => {
      if (value) {
        setValue(value / INTERVAL_TIME_UNITS[time_unit_value] * INTERVAL_TIME_UNITS[unit_0]);
      }
    };
    $[28] = setValue;
    $[29] = time_unit_value;
    $[30] = value;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== time_unit_options) {
    t18 = time_unit_options.map(_temp);
    $[32] = time_unit_options;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t18) {
    t19 = <SelectInput m={0} name={t16} onChange={t17} options={t18} />;
    $[34] = t16;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t15 || $[39] !== t19) {
    t20 = <Div flex={t11}><StyledFieldWrapper>{t15}{t19}</StyledFieldWrapper></Div>;
    $[38] = t15;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== help) {
    t21 = help && <Text m={{
      t: 1,
      b: 0
    }} size="s" as="p" muted={true}>{help}</Text>;
    $[41] = help;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== error || $[44] !== submitCount || $[45] !== touched) {
    t22 = (touched || submitCount > 0) && error && <Text m={{
      top: 1,
      bottom: 0
    }} as="p" danger={true}>{error}</Text>;
    $[43] = error;
    $[44] = submitCount;
    $[45] = touched;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t10 || $[48] !== t20 || $[49] !== t21 || $[50] !== t22) {
    t23 = <Div>{t10}{t20}{t21}{t22}</Div>;
    $[47] = t10;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};
export default IntervalInput;
function _temp(unit_1) {
  return {
    label: unit_1,
    value: unit_1
  };
}